export const currencySymbol = (currency = 'USD') => {
  const c = currency?.toUpperCase();

  const map: Record<string, string> = {
    CAD: 'C$',
    INR: 'INR',
    'INDIAN RUPEE': 'INR',
    USD: '$',
  };

  return map[c] || '$';
};
